import { t } from '@lingui/core/macro';
import { Box } from '@mui/material';
import * as React from 'react';
import type { JSX } from 'react';

import { ToggleButton } from '../../../ToggleButton/ToggleButton';
import { ToggleButtonItem } from '../../../ToggleButton/ToggleButtonItem';

export type DatePickerGranularity = 'day' | 'month' | 'quarter' | 'year';

export const ALL_GRANULARITIES: DatePickerGranularity[] = ['day', 'month', 'quarter', 'year'];

export interface GranularityTabsProps {
    value: DatePickerGranularity;
    onChange: (next: DatePickerGranularity) => void;
    options?: DatePickerGranularity[];
}

export function GranularityTabs({ value, onChange, options = ALL_GRANULARITIES }: GranularityTabsProps): JSX.Element {
    const labels: Record<DatePickerGranularity, string> = {
        day: t`Day`,
        month: t`Month`,
        quarter: t`Quarter`,
        year: t`Year`,
    };

    return (
        <Box sx={{ padding: '8px 8px 0' }}>
            <ToggleButton
                value={value}
                exclusive
                onChange={(_e, next: DatePickerGranularity | null) => {
                    if (next) onChange(next);
                }}
                aria-label={t`Date granularity`}
                fullWidth
            >
                {options.map((g) => (
                    <ToggleButtonItem key={g} value={g} aria-label={labels[g]}>
                        {labels[g]}
                    </ToggleButtonItem>
                ))}
            </ToggleButton>
        </Box>
    );
}
